// Runtime blue/green selection for the unified load balancer.
//
// Builds are colour-agnostic: every build targets the stable API domain and
// the load balancer decides which colour serves each request. The live host
// (wallet.upapp.uk) sends nothing — the LB default routes to the live colour.
// Preview hosts encode their colour in the hostname (green-wallet.upapp.uk,
// green---upapp-….run.app) and pin it explicitly, so a staging app always
// talks to the matching staging API. QA can force a colour on any host via
// localStorage.setItem('api-colour', 'blue' | 'green').

type Colour = 'blue' | 'green'

const isColour = (value: string | null): value is Colour =>
  value === 'blue' || value === 'green'

export const apiColour = (): Colour | null => {
  if (typeof window === 'undefined') return null
  const override = window.localStorage.getItem('api-colour')
  if (isColour(override)) return override
  const match = window.location.hostname.match(/^(blue|green)-/)
  return match && isColour(match[1]) ? match[1] : null
}

// Top-level navigations (e.g. wallet pass downloads) cannot carry headers,
// so the LB also routes on an `up-color` query parameter.
export const withApiColour = (url: string): string => {
  const colour = apiColour()
  if (!colour) return url
  const parsed = new URL(url)
  parsed.searchParams.set('up-color', colour)
  return parsed.toString()
}
